import { z } from 'zod';

/**
 * Libreria audio tenant (`/api/audio/*`, pagina Audio Manager + player IVR).
 * Source of truth: `packages/backend/src/routes/media/audio.routes.ts`
 * (`rowToFileShape` per i file, `AUDIO_CATEGORY_META` per le directory).
 *
 *  - `GET /audio/dirs`          → `data: AudioDirectory[]`
 *  - `GET /audio/list?dir=`     → `data: AudioListData`
 *  - `POST /audio/upload`       → `data: AudioFile`
 *  - `PATCH /audio/rename`      → `data: AudioRenameData`
 *  - `DELETE /audio/file?path=` → `data: AudioDeleteData`
 */

export const audioDirectorySchema = z
  .object({
    category: z.string(),
    label: z.string(),
    icon: z.string(),
    path: z.string(),
    evergreen: z.boolean(),
    totalSize: z.number(),
    totalSizeFormatted: z.string(),
    fileCount: z.number(),
  })
  .passthrough();
export type AudioDirectory = z.infer<typeof audioDirectorySchema>;

export const audioFileSchema = z
  .object({
    id: z.string().optional(),
    filename: z.string(),
    path: z.string(),
    size: z.number(),
    sizeFormatted: z.string(),
    duration: z.number().nullable(),
    durationFormatted: z.string().nullable(),
    mimeType: z.string(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    tenantId: z.string().nullable(),
    isEvergreen: z.boolean(),
  })
  .passthrough();
export type AudioFile = z.infer<typeof audioFileSchema>;

export const audioListDataSchema = z
  .object({
    category: z.string().optional(),
    label: z.string(),
    path: z.string().optional(),
    evergreen: z.boolean(),
    files: z.array(audioFileSchema),
  })
  .passthrough();
export type AudioListData = z.infer<typeof audioListDataSchema>;

export const audioRenameDataSchema = z.object({
  oldPath: z.string(),
  newPath: z.string(),
  filename: z.string(),
});
export type AudioRenameData = z.infer<typeof audioRenameDataSchema>;

export const audioDeleteDataSchema = z.object({
  deletedPath: z.string(),
  filename: z.string(),
});
export type AudioDeleteData = z.infer<typeof audioDeleteDataSchema>;
